import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconArrowPathLeft"><Path d="M8.94751 4.3626C9.76105 3.68099 11.0003 4.2594 11.0003 5.32075V7.99954H19.2503C20.7691 7.99954 22.0003 9.23075 22.0003 10.7495V13.2495C22.0003 14.7683 20.7691 15.9995 19.2503 15.9995H11.0003V18.6783C11.0003 19.7397 9.76106 20.3181 8.94751 19.6365L1.89094 13.7242C0.817604 12.8249 0.8176 11.1741 1.89094 10.2749L8.94751 4.3626Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathLeft;
